// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610160713/js/" + chunkId + "." + {"44":"cab514c5","225":"b8dafcb5","481":"9e25ea6e","486":"4882da15","770":"10e4f42a"}[chunkId] + ".0.7169115007853657.chunk.js";
};